import { FC } from "react";
import { HStack } from "@design-system/HStack/HStack";
import { Button } from "@design-system/Button/Button";
import { GroupDescriptor } from "./groupByRowTypes";
import styles from "./grouping.module.scss";

export const GroupHeaderContent: FC<{ descriptor: GroupDescriptor }> = ({
    descriptor,
}) => (
    <HStack gap={8} align="center">
        {descriptor.icon ??
            (descriptor.iconUrl ? (
                <img
                    className={styles.groupIcon}
                    src={descriptor.iconUrl}
                    alt=""
                    aria-hidden="true"
                />
            ) : null)}
        <span className={styles.groupHeader}>{descriptor.label}</span>
        <span className={styles.groupCount}>{descriptor.totalCount}</span>
    </HStack>
);

export const GroupLoadMoreContent: FC<{
    remainingCount: number;
    onLoadMore: () => void;
}> = ({ remainingCount, onLoadMore }) => (
    <HStack justify="center">
        <Button variant="primary" size="md" onClick={onLoadMore}>
            {`Load ${remainingCount} more`}
        </Button>
    </HStack>
);

export const GroupLoadErrorContent: FC<{ onRetry: () => void }> = ({
    onRetry,
}) => (
    <HStack gap={8} align="center" className={styles.errorRow}>
        <span>Couldn&apos;t load these rows.</span>
        <Button variant="link" size="sm" onClick={onRetry}>
            Retry
        </Button>
    </HStack>
);
